var BrandArray = new Array("1|HTP America",
"2|AHP",
"3|Astro",
"4|ATD",
"5|Auto Arc",
"6|Cebora",
"7|Century",
"8|Chicago Electric",
"9|Clarke",
"10|Dayton",
"11|Daytona",
"12|Eastwood",
"13|Elektron",
"14|Harbor Freight",
"15|Hypertherm",
"16|MAC Tools",
"17|Marquette",
"18|MATCO",
"19|NAPA",
"20|Northern Tool",
"21|Power Arc",
"22|Pro-Arc",
"23|Razorweld",
"24|Schumacher Electric",
"25|Snap-On",
"26|Solar",
"27|Speedway",
"28|Tecmo",
"29|Thermal Dynamics",
"30|Trafimet");//Plasma

var ModelArray1 = new Array("1|MicroCut 45 DV",
 "2|MicroCut 600",
 "3|MicroCut 200",
"4|MicroCut 201",
"5|MicroCut 250RF",
"6|MicroCut 300",
"7|MicroCut 301",
"8|MicroCut 380",
"9|MicroCut 400",
"10|MicroCut 625",
"11|MicroCut 625-45",
"12|MicroCut 875S",
"13|MicroCut 875SC Hand Torch",
"14|MicroCut 875SC Machine Torch",
"15|MicroCut 875SC v2 Hand Torch",
"16|MicroCut 875SC v2 Machine Torch");//HTP America

var ModelArray2 = new Array("1|Alpha Cut 60");//AHP Models - Plasma

var ModelArray3 = new Array("1|5001",
"2|Plasma 250",
"3|Plasma 300 200V",
"4|Plasma 300 200-230V",
"5|Plasma 450 208-230V",
"6|Plasma 450M",
"7|Plasma 475",
"8|Plasma 500 208-230V");//Astro - Plasma

var ModelArray4 = new Array("1|37125",
"2|37150");//Eastwood

var ModelArray5 = new Array("1|Plasma 40");//Auto Arc

var ModelArray6 = new Array("1|CP40",
"2|CP-95C",
"3|P30",
"4|P70",
"5|Plasma Prof 30",
"6|Plasma Prof 35HF",
"7|Plasma Prof 37C",
"8|Plasma Prof 50",
"9|Plasma Prof 52",
"10|Plasma Prof 55",
"11|Plasma Prof 70",
"12|Plasma Prof 92",
"13|Plasma Prof 942",
"14|Plasma Prof 943",
"15|Pocket Plasma 25",
"16|Sound 35PC");//Cebora

var ModelArray7 = new Array("1|20-20",
"2|20-40",
"3|20-50",
"4|4020 118-002",
"5|4020 118-007",
"6|82020 118-009",
"7|82021 118-023",
"8|82050 118-016",
"9|82051 118-025");//Century

var ModelArray8 = new Array("1|60767",
"2|62204",
"3|91814",
"4|93156",
"5|95136",
"6|Plasma 30",
"7|Plasma 35 08882",
"8|Plasma 36",
"9|Plasma 40",
"10|Plasma 92652");//Chicago Electric

var ModelArray9 = new Array("1|Plasma King 20",
"2|Plasma King 30",
"3|Plasma King 35",
"4|Plasma King 45");//Clarke

var ModelArray10 = new Array("1|3W722 118-009",
"2|5Z031 118-004",
"3|5Z031A 118-016",
"4|5Z031B 118-016",
"5|5Z135 118-013");//Dayton

var ModelArray11 = new Array("1|Plasma Pocket 25",
"2|Plasma Prof 35HF",
"3|Plasma Prof 36M",
"4|Plasma Prof 52M");//Daytona

var ModelArray12 = new Array("1|Versa Cut 20",
"2|Versa Cut 40",
"3|Versa Cut 60");//Eastwood

var ModelArray12 = new Array("1|Multi-Cutter MC 40");//Elektron

var ModelArray13 = new Array("1|60767",
"2|95136",
"3|Plasma 30",
"4|Plasma 35 08882",
"5|Plasma 36",
"6|Plasma 40 41952",
"7|Plasma 92652");//Harbor Freight

var ModelArray15 = new Array("1|HT 40",
"2|Max 20",
"3|Max 40",
"4|Max 40CS",
"5|Max 42",
"6|Max 43",
"7|PAC 110",
"8|PAC 120",
"9|PAC 140",
"10|Powermax45 Gouging",
"11|Powermax45 Hand Torch",
"12|Powermax45 Machine Torch",
"13|Powermax45XP Fine Cut",
"14|Powermax45XP Hand Torch",
"15|Powermax45XP Machine Torch",
"16|Powermax65 Extended",
"17|Powermax65 Fine Cut",
"18|Powermax65 Gouging",
"19|Powermax65 Hand Torch",
"20|Powermax65 Machine Torch",
"21|Powermax85 Extended",
"22|Powermax85 Fine Cut",
"23|Powermax85 Gouging",
"24|Powermax85 Hand Torch",
"25|Powermax85 Machine Torch");//Hypertherm

var ModelArray16 = new Array("1|PCA-20PS",
"2|PCA-30PS",
"3|PCS 20",
"4|PCS 200",
"5|PCS 25");//MAC Tools

var ModelArray17 = new Array("1|12-150",
"2|M12149",
"3|M12150",
"4|M12151",
"5|M12152",
"6|M12155",
"7|M12156",
"8|M12157",
"9|M15802");//Marquette

var ModelArray18 = new Array("1|Mplasma 25",
"2|PCS 20 118-009",
"3|PCS 25 118-021",
"4|PCS 3800-11");//MATCO

var ModelArray19 = new Array("1|83-329",
"2|83-382",
"3|83-383",
"4|83-384");//NAPA

var ModelArray20 = new Array("1|Plasma 375");//Northern Tool

var ModelArray21 = new Array("1|Plasma 35 190206");//Power Arc

var ModelArray22 = new Array("1|2500");//Pro-Arc

var ModelArray23 = new Array("1|JRWPC45LT Plasma 45");//Razorweld

var ModelArray24 = new Array("1|Plasma 25A 92026",
"2|Plasma 25A 92035",
"3|Plasma 25N 90205",);//Schumacher Electric

var ModelArray25 = new Array("1|Blue Point Plasma 230",
"2|Plasma 115",
"3|Plasma 25",
"4|Plasma 30i",
"5|Plasma 50",
"6|Plasma 60i",
"7|YA2001 118-003",
"8|YA2001A 118-005",
"9|YA2120 118-011",
"10|YA2225",
"11|YA2230 118-008",
"12|YA5550 118-014",
"13|YA5550A");//Snap-On

var ModelArray26 = new Array("1|2010 118-012",
"2|2020 118-010",
"3|2040 118-002",
"4|2040 118-004",
"5|2040 118-006",
"6|2050 118-015");//Solar

var ModelArray27 = new Array("1|Plasma 30");//Speedway
 
 var ModelArray28 = new Array("1|40C",
"2|PT-40",
"3|PT-60");//Tecmo

 var ModelArray29 = new Array("1|1Torch",
"2|4Xi",
"3|6Xi",
"4|Pak-3XR",
"5|Pak-5XT",
"6|Pak-625XR",
"7|Pak-6XR",
"8|Pak-750XR",
"9|Pak-7XR",
"10|PCH-51",
"11|PCM-51");//Thermal Dynamics

 var ModelArray30 = new Array("1|CB50",
"2|S45",
"3|S54");//Trafimet

 

function loadBrand()
{
	var selectBrand = document.getElementById("selectBrand");

	if (selectBrand != null && BrandArray != null)
	{
		loadOptions(selectBrand, BrandArray, "- Brand -");	
	}	
}

function loadOptions(select, list, initOption)
{
	if (select != null && list != null)
	{
		select.options.length = 0;
		select.options[select.options.length] = new Option(initOption, "-1");
		for (i = 0; i < list.length; i++)
		{
			var opt = list[i].split("|");
			select.options[select.options.length] = new Option(opt[1], opt[0]);
		}
	}
}

function loadJoes(select, list, initOption)
{
	if (select != null && list != null)
	{
		select.options.length = 0;
		select.options[select.options.length] = new Option(initOption, "-1");
		for (i = 0; i < list.length; i++)
		{
			var opt = list[i];
			select.options[select.options.length] = new Option(opt, opt);
		}
	}
}

function resetSelect(select)
{
	var btnSearch = document.getElementById("btnSearch");

	select.options[0].selected = true;
	select.disabled = true;
	btnSearch.disabled = true;
}

function changeBrand()
{
	var selectBrand = document.getElementById("selectBrand");
	var selectModel = document.getElementById("selectModel");
	var selectJoe = document.getElementById("selectJoe");

		
	if (selectBrand != null)
	{
		if (selectBrand.value != "-1")
		{
			if (selectModel != null)
			{
				loadOptions(selectModel, eval("ModelArray" + selectBrand.value), "- Model -");
				selectModel.disabled = false;
				resetSelect(selectJoe);

			}		
		}
		else
		{
			resetSelect(selectModel);	
			resetSelect(selectJoe);

		}
	}
}

function changeModel()
{
	var selectModel = document.getElementById("selectModel");
	//*var selectJoe = document.getElementById("selectJoe");
	var override = false;

	if (selectModel != null)
	{
		if (selectJoe != null)
		{
			if (selectModel.value != "-1")
			{
				try
				{
					eval("JoeArray" + selectModel.value);
					override = true;
				}
				catch(err)
				{
					override = false;
				}
			
				if (override)
				{
					loadJoes(selectJoe, eval("JoeArray" + selectModel.value), "- Joe -");

				}
				else
				{
					loadJoes(selectJoe, JoeArrayDefault, "- Joe -");

				}
				selectJoe.disabled = false;
			}
			else
			{
				resetSelect(selectJoe);

			}
		}
	}
	else
	{
		resetSelect(selectJoe);
	}
}

function changeJoe()
{
	var selectJoe = document.getElementById("selectJoe");
	var btnSearch = document.getElementById("btnSearch");
	var override = false;

	if (selectJoe != null)
	{
		if (selectJoe.value != "-1")
		{

			btnSearch.disabled = false;
		}
		else
		{

			btnSearch.disabled = false;
		}
	}
}

function performSearch()
{
	var selectBrand = document.getElementById("selectBrand");
	var selectModel = document.getElementById("selectModel");
	//*var selectJoe = document.getElementById("selectJoe");

	
	if (selectModel != null)
	{
		//*var mod = selectJoe.options[selectJoe.selectedIndex].text;
var Brand = selectBrand.options[selectBrand.selectedIndex].text.replace(' ', '_' ).split(' ').join('_');

var Model = selectModel.options[selectModel.selectedIndex].text.replace(' ', '_' ).split(' ').join('_');
      
		var url = "https://usaweld.com/collections/";
	
        url += Brand + "_" + Model;

		doSearch(url); 		
	}
}

function doSearch(url)
{
		top.location.href = url; 
}// JavaScript Document// JavaScript Document